import UserService from "@/services/user.service";

export function getCurrentMemberId(user) {
  const raw = user?.member_id ?? user?.id;
  if (raw == null || raw === "") return null;
  const n = parseInt(String(raw), 10);
  return Number.isNaN(n) ? null : n;
}

function pickCenters(response) {
  const data = response?.data?.data;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data)) return data;
  if (Array.isArray(response?.data?.list)) return response.data.list;
  return [];
}

function filterByInvigilator(list, memberId) {
  if (!Array.isArray(list) || !memberId) return [];
  return list.filter((center) => {
    const cid = parseInt(String(center?.invigilator_member_id ?? ""), 10);
    return !Number.isNaN(cid) && cid === memberId;
  });
}

async function safeFetch(params) {
  try {
    const response = await UserService.authGetRequest("qhls-exam-centers", params);
    return pickCenters(response);
  } catch (e) {
    return [];
  }
}

function buildInvigilatorFetchParams(currentUser) {
  const zoneId = currentUser?.zone_id;
  const unitId = currentUser?.unit_id;
  // invigilator: 1 asks the backend to return only centers where the caller is
  // the invigilator, instead of the whole zone/unit list.
  const params = { invigilator: 1 };
  if (zoneId) params.zone_id = zoneId;
  if (unitId) params.unit_id = unitId;
  return params;
}

let invigilatorCentersCache = null;
let invigilatorCentersCacheKey = null;

/** Unit/zone members only — state/district org pages already expose QHLS tiles. */
export function shouldFetchInvigilatorCenters(currentUser) {
  if (!currentUser || !getCurrentMemberId(currentUser)) return false;
  const level = parseInt(String(currentUser.user_level), 10);
  return level === 3 || level === 4;
}

export async function fetchMyInvigilatorCenters(currentUser, { force = false } = {}) {
  const memberId = getCurrentMemberId(currentUser);
  if (!memberId || !shouldFetchInvigilatorCenters(currentUser)) return [];

  const cacheKey = `${memberId}:${currentUser?.zone_id || ""}:${currentUser?.unit_id || ""}`;
  if (!force && invigilatorCentersCacheKey === cacheKey && invigilatorCentersCache) {
    return invigilatorCentersCache;
  }

  const list = await safeFetch(buildInvigilatorFetchParams(currentUser));
  const mine = filterByInvigilator(list, memberId);
  invigilatorCentersCacheKey = cacheKey;
  invigilatorCentersCache = mine;
  return mine;
}

export function clearInvigilatorCentersCache() {
  invigilatorCentersCache = null;
  invigilatorCentersCacheKey = null;
}

export function qhlsInvigilatorCenterRoute(centers, currentUser) {
  const first = Array.isArray(centers) && centers.length ? centers[0] : null;
  const unitId = first?.unit_id ?? currentUser?.unit_id;
  if (!unitId) return null;
  return `/org/4/${unitId}/qhls-exam-center`;
}
